// Phase 6.3.2 — shared overlay (Modal + SidePanel) dismissal stack.
//
// When overlays stack (e.g. a Modal opened over a SidePanel, or a
// StepUpAuthModal over an AddUserModal), a single Esc must close
// only the TOPMOST overlay — not collapse the whole stack. Both
// primitives register here on open and gate their Esc handler on
// `isTopOverlay`, so dismissal behaves consistently everywhere
// (the UX review flagged ad-hoc, inconsistent dismissal).

const stack: symbol[] = [];

export function pushOverlay(id: symbol): void {
  stack.push(id);
}

export function popOverlay(id: symbol): void {
  const i = stack.lastIndexOf(id);
  if (i !== -1) stack.splice(i, 1);
}

export function isTopOverlay(id: symbol): boolean {
  return stack.length > 0 && stack[stack.length - 1] === id;
}
